import { IconProps } from "./types"

const Menu = ({ color = "#100069", onClick }: IconProps) => {
    return (
        <svg fill={color} viewBox="0 0 50 50" width="50px" height="20px" onClick={onClick} className="cursor-pointer">
            <path d="M 0 9 L 0 11 L 50 11 L 50 9 Z M 0 24 L 0 26 L 50 26 L 50 24 Z M 0 39 L 0 41 L 50 41 L 50 39 Z" />
        </svg>
    )
}

export default Menu